import React from 'react'
import Loader from '../loader/loader'
import './button.scss'

const WrapperButton = props => {
  return props.type === 'link' ? (
    <a {...props}>{props.children}</a>
  ) : (
    <button {...props}>{props.children}</button>
  )
}

export const Button = ({
  text,
  action,
  color,
  icon,
  isDisabled = false,
  isLoading = false,
  className = '',
  ...props
}) => {
  return (
    <WrapperButton
      className={
        'f-btn ' +
        (color ? `f-btn--${color} ` : '') +
        (icon ? 'f-btn--icon ' : '') +
        (isDisabled || isLoading ? 'disabled ' : '') +
        className
      }
      onClick={e => action && !isDisabled && !isLoading && action(e)}
      {...props}
    >
      <>
        {icon && <span className={`f-btn__icon ${icon}`} />}
        {text && <p className="f-btn__text">{text}</p>}
        {isLoading && <Loader class={color} />}
      </>
    </WrapperButton>
  )
}
